// extracted by mini-css-extract-plugin
export default {"Discovery":"Discovery_Discovery__-WP7U","Title":"Discovery_Title__sW93H","Subtitle":"Discovery_Subtitle__vtfkx"};